import { Input } from '@mantine/core'
import classes from './styles.module.css'

export const InputTheme = Input.extend({
    classNames: { wrapper: classes.wrapper, input: classes.input, section: classes.section },
})

export const InputWrapperTheme = Input.Wrapper.extend({ classNames: { label: classes.label } })
